import { DropdownItemEventTypeInput } from '../types/ViewModel/DropdownItemEventTypeInput';
import { DropdownItemEventTypeInputBM } from '../types/BusinessModel/DropdownItemEventTypeInputBM';

export class DropdownItemEventTypeInputFactory {
    public newDropdownItemEventTypeInput(dropdownItemEventTypeInput: DropdownItemEventTypeInputBM): DropdownItemEventTypeInput {
        return new DropdownItemEventTypeInput(
            dropdownItemEventTypeInput.dropdownItemEventTypeInputId,
            dropdownItemEventTypeInput.dropdownItemId,
            dropdownItemEventTypeInput.eventTypeInputId,
            dropdownItemEventTypeInput.mandatory
        );
    }

    public createDropdownItemEventTypeInputArray(dropdownItemEventTypeInputArray: DropdownItemEventTypeInput[]): DropdownItemEventTypeInput[] {
        const drItemEvTypeInpArray: DropdownItemEventTypeInput[] = [];
        if (dropdownItemEventTypeInputArray && dropdownItemEventTypeInputArray.length > 0) {
            dropdownItemEventTypeInputArray.map((dieti) => drItemEvTypeInpArray.push(this.createDropdownItemEventTypeInput(dieti)));
        }
        return drItemEvTypeInpArray;
    }

    public createDropdownItemEventTypeInput(dropdownItemEventTypeInput: DropdownItemEventTypeInput): DropdownItemEventTypeInput {
        return new DropdownItemEventTypeInput(
            dropdownItemEventTypeInput.dropdownItemEventTypeInputId,
            dropdownItemEventTypeInput.dropdownItemId,
            dropdownItemEventTypeInput.eventTypeInputId,
            dropdownItemEventTypeInput.mandatory
        );
    }
}
